import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
    th: {
        fontWeight: 'bold',
        borderTop: 'none !important',
        borderBottom: 'none !important',
        fontSize: '16px',
    },
    totalRow: {
        '& > tr': {
            '& > td:nth-child(4)': {
                paddingLeft: '20px !important',
            },
        },
    },
    td: {
        borderTop: 'none !important',
        borderRight: '1px solid rgba(0,0,0,0.02) !important',
    },
    tableContainer: {
        display: 'block',
        maxWidth: '100%',
    },
    table: {
        minWidth: '100px !important',
    },
    tbody: {
        '& > tr': {
            '& > td:nth-child(4)': {
                '& > div[class^="empty-budget"]': {
                    textAlign: 'initial !important',
                },
            },
        },
    },
});
